/**
 * 诊断解锁三步弹窗 EdgenModal 外壳（H5 全屏 / PC 居中卡片）。
 *
 * PC（Figma `90772:43086`）：宽 480px，高度由内容撑开，`max-height: 90dvh`。
 * 模式对齐 `openPortfolioScreenshotModal`（`--modal-height:auto` + `--modal-max-height`）。
 */

/** Figma `90772:43086` — PC 弹窗外壳宽度 */
export const DIAGNOSIS_UNLOCK_MODAL_PC_WIDTH_PX = 480;

/** PC 弹窗最大高度（Step 2/3 内容超出时壳层 + 步内滚动） */
export const DIAGNOSIS_UNLOCK_MODAL_PC_MAX_HEIGHT = "90dvh";

/** step1 Loading 固定高度 */
export const DIAGNOSIS_UNLOCK_MODAL_PC_LOADING_HEIGHT_PX = 674;

/** step1 默认背景 */
export const DIAGNOSIS_UNLOCK_STEP1_BACKGROUND_SRC =
  "/assets/images/onboard-bg.webp";

export const DIAGNOSIS_UNLOCK_MODAL_PROPS = {
  className:
    "[--modal-radius:0px] md:[--modal-radius:24px] [--modal-width:100%] [--modal-height:100dvh] [--modal-min-height:0px] [--modal-max-height:none] md:[--modal-width:480px] md:[--modal-height:auto] md:[--modal-min-height:0px] md:[--modal-max-height:90dvh]",
  contentStyle: {
    borderRadius: "var(--modal-radius)",
    width: "var(--modal-width)",
    height: "var(--modal-height)",
    minHeight: "var(--modal-min-height)",
    maxHeight: "var(--modal-max-height)",
    overflow: "hidden" as const,
    padding: 0,
  },
  styles: {
    body: {
      height: "var(--modal-height)",
      minHeight: "var(--modal-min-height)",
      maxHeight: "var(--modal-max-height)",
    },
  },
  containerStyle: {
    height: "100%",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  titleStyle: {
    minHeight: 0,
  },
  showClose: false,
  maskClosable: false,
  destroyOnClose: true,
} as const;
